import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import classNames from 'classnames/bind';
import styles from './Circle.css';
var cx = classNames.bind(styles);

var Dot = function Dot() {
  return /*#__PURE__*/React.createElement("div", {
    className: cx('dot')
  });
};

export var Circle = function Circle(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('root', _defineProperty({}, "size_".concat(size), size))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('content')
  }, /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null), /*#__PURE__*/React.createElement(Dot, null)));
};